import { useMemo } from 'react';
import ReactModal from 'react-modal';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../assets/css/onload-popup.css';

import Popup01 from '../assets/images/popup-slider/popup-04.jpeg';
import Popup02 from '../assets/images/popup-slider/popup-01.png';
import Popup03 from '../assets/images/popup-slider/popup-02.jpeg';
import Popup04 from '../assets/images/popup-slider/popup-03.jpg';

const POPUP_SLIDES = [
  { src: Popup01, alt: 'India AI Impact Festival 2026' },
  { src: Popup02, alt: 'Rainbow International School — Admissions' },
  { src: Popup03, alt: 'School announcement' },
  { src: Popup04, alt: 'Rainbow International School' },
];

const POPUP_LINK =
  'https://www.facebook.com/story.php?story_fbid=1064220435492393&id=100057133403626&rdid=d9tqrXLQOdmahOHP';

function PrevArrow({ className, style, onClick }) {
  return (
    <button
      type="button"
      className={`onload-popup-arrow onload-popup-arrow--prev ${className || ''}`}
      style={{ ...style, display: 'flex' }}
      onClick={onClick}
      aria-label="Previous slide"
    >
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M15 6l-6 6 6 6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  );
}

function NextArrow({ className, style, onClick }) {
  return (
    <button
      type="button"
      className={`onload-popup-arrow onload-popup-arrow--next ${className || ''}`}
      style={{ ...style, display: 'flex' }}
      onClick={onClick}
      aria-label="Next slide"
    >
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  );
}

const MODAL_STYLES = {
  overlay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    inset: 0,
    padding: '1.25rem',
    zIndex: 99999,
  },
  content: {
    position: 'relative',
    inset: 'unset',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    transform: 'none',
    margin: 0,
    padding: 0,
    border: 'none',
    background: 'transparent',
    overflow: 'visible',
    width: '100%',
    maxWidth: '700px',
    height: 'auto',
  },
};

function OnloadPopup({ isOpen, onClose }) {
  const sliderSettings = useMemo(
    () => ({
      dots: true,
      arrows: POPUP_SLIDES.length > 1,
      infinite: POPUP_SLIDES.length > 1,
      speed: 600,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnHover: true,
      pauseOnFocus: true,
      fade: true,
      cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
      adaptiveHeight: false,
      prevArrow: <PrevArrow />,
      nextArrow: <NextArrow />,
      appendDots: (dots) => (
        <div className="onload-popup-dots-wrap">
          <ul className="onload-popup-dots">{dots}</ul>
        </div>
      ),
      customPaging: () => <button type="button" className="onload-popup-dot" aria-label="Go to slide" />,
    }),
    []
  );

  return (
    <ReactModal
      className="onload-popup-modal"
      overlayClassName="onload-popup-overlay"
      style={MODAL_STYLES}
      isOpen={isOpen}
      onRequestClose={onClose}
      closeTimeoutMS={280}
      ariaHideApp={false}
      contentLabel="School announcements"
    >
      <div className="onload-popup-card">
        <div className="onload-popup-header">
          <div className="onload-popup-header-text">
            <span className="onload-popup-badge">Updates</span>
            <h2 className="onload-popup-title">Rainbow International School</h2>
          </div>
          <button type="button" className="onload-popup-close" onClick={onClose} aria-label="Close popup">
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        <div className="onload-popup-slider-wrap">
          <Slider {...sliderSettings} className="onload-popup-slider">
            {POPUP_SLIDES.map((slide, index) => (
              <div key={index} className="onload-popup-slide">
                <a
                  href={slide.link || POPUP_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="onload-popup-link"
                  onClick={onClose}
                >
                  <img src={slide.src} alt={slide.alt} loading="eager" />
                </a>
              </div>
            ))}
          </Slider>
        </div>

        <p className="onload-popup-caption">Tap any slide to view details</p>
      </div>
    </ReactModal>
  );
}

export default OnloadPopup;
